<script>
import BoardingTaskPage from "@/views/Boarding/BoardingTask/BoardingTaskPage.vue";

export default {
    components: {BoardingTaskPage}
}
</script>

<template>
    <boarding-task-page  intranet/>
</template>

